import { keyBy, mapValues, isArray } from "lodash-es";

// https://stackoverflow.com/a/40939107
export const deepKeyBy = (arr: unknown[], key: string): any => {
  return keyBy(
    arr.map((object: any) => {
      // map each object in the array
      return mapValues(object, (value) => {
        // map the properties of the object
        // if the property value is an array, run deepKeyBy() on it
        return isArray(value) ? deepKeyBy(value, key) : value;
      });
    }),
    key // index the object by the key
  );
};
